/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChangePasswordDto } from '../models/ChangePasswordDto';
import type { ForceChangePasswordDto } from '../models/ForceChangePasswordDto';
import type { LoginDto } from '../models/LoginDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthService {
  /**
   * User login
   * @param requestBody
   * @returns any User successfully logged in
   * @throws ApiError
   */
  public static authControllerLogin(requestBody: LoginDto): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/login',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Invalid credentials`,
        429: `Too many requests`,
      },
    });
  }
  /**
   * Get user profile
   * @returns any Returns the user profile
   * @throws ApiError
   */
  public static authControllerGetProfile(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/auth/profile',
      errors: {
        401: `Unauthorized`,
      },
    });
  }
  /**
   * Change own password (voluntary)
   * @param requestBody
   * @returns any Password changed successfully
   * @throws ApiError
   */
  public static authControllerChangePassword(
    requestBody: ChangePasswordDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/auth/change-password',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Invalid current password or same password`,
        401: `Unauthorized`,
      },
    });
  }
  /**
   * Forced password change after admin reset
   * @param requestBody
   * @returns any Password changed, please login again
   * @throws ApiError
   */
  public static authControllerForceChangePassword(
    requestBody: ForceChangePasswordDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/auth/force-change-password',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `No pending password change or validation error`,
        401: `Unauthorized`,
      },
    });
  }
}
